export default __webpack_public_path__ + "static/media/tag.21002ca9.png";